export class GeneralPrePhotosModel {
  preInstallBoilerRoomImages: { image: string }[];
  preInstallHeatingImages: { image: string }[];

  constructor() {
    this.preInstallBoilerRoomImages = [];
    this.preInstallHeatingImages = [];
  }

  public static initialize(model: GeneralPrePhotosModel): void {
    if (!model.preInstallBoilerRoomImages) {
      model.preInstallBoilerRoomImages = [];
    }
    while (model.preInstallBoilerRoomImages.length < 3) {
      model.preInstallBoilerRoomImages.push({image: null})
    }

    if (!model.preInstallHeatingImages || model.preInstallHeatingImages.length === 0) {
      model.preInstallHeatingImages = [{image: null}];
    }
  }
}
